import { Component, Input, OnChanges, OnInit, OnDestroy, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CarouselComponent, OwlOptions } from 'ngx-owl-carousel-o';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FilterListModel, FilterSubsListObj } from 'src/app/models/filter-list-model';
import { PlaylistModel } from 'src/app/models/play-list.model';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { Ga4trackingService } from 'src/app/services/ga4Tracking/ga4tracking.service';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';
import { BeatsService } from 'src/app/services/beats-service/beats.service';
import { PlayerService } from 'src/app/services/music-player/player.service';
@Component({
  selector: 'ipm-common-section',
  templateUrl: './common-section.component.html',
  styleUrls: ['./common-section.component.scss']
})
export class CommonSectionComponent  implements OnInit, OnChanges, OnDestroy {
  private destroy$ = new Subject<void>();
  currentPlayingPlaylistId: string | null = null;
  isPlaying: boolean = false;

  recommendedLists:Array<any> =[];
  @Input() type: string = ""
  @Input() heading: string = ""
  @Input() playListData: Array<PlaylistModel> = [];
  @Input() trendingBeatsData: Array<any> = [];
  @Input() adsBeatsData: Array<any> = [];
  @Input() newFindsData: Array<any> = [];
  @Input() bpmBeatsList: Array<any> = [];
  @Input() playlistSlug: string = "";
  trendingBeatsList: Array<any> = [];
  emptyListArray: Array<any> = [1,2,3,4,5];
  @ViewChild('owlCar') owlCar!: CarouselComponent;
  customOptions: OwlOptions = {
    center: false,
    responsiveRefreshRate: 0,
    dots: false,
    nav: false,
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    autoWidth: false,
    pullDrag: true,
    mergeFit: true,
    lazyLoad: true,
    items: 5,
    slideBy: 5,
    navText: ["", ""],
    responsive: {
      0: { items: 2.2, slideBy: 1 },
      565: { items: 3, slideBy: 3 },
      767: { items: 4, slideBy: 4 },
      992: { items: 4, slideBy: 4 },
      1250: { items: 5, slideBy: 5 }
    }
  }
  sectionType: string = "";
  currentPlayBeatData: any = "";
  constructor(public commonFunction: CommonService,
    public browserService: BrowserStorageService,
    public ga4Service: Ga4trackingService,
    public route: Router,
    private beatsService: BeatsService,
    private playerService: PlayerService) {
      let customOptionsLink: any =  JSON.parse(JSON.stringify(this.customOptions));
      customOptionsLink.nav = this.type !== 'recommended' ? false : true;
      customOptionsLink.loop = this.type !== 'recommended' ? true : false;
      customOptionsLink.mouseDrag = this.type !== 'recommended' ? true : false;
      customOptionsLink.touchDrag = this.type !== 'recommended' ? true : false;
      customOptionsLink.pullDrag = this.type !== 'recommended' ? true : false;
      this.customOptions = JSON.parse(JSON.stringify(customOptionsLink));
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['trendingBeatsData'] &&  this.trendingBeatsData)  {
            this.trendingBeatsList = this.trendingBeatsData;
        }
    }


  ngOnInit(): void {
    this.beatsService.currentPlayBeat.pipe(takeUntil(this.destroy$)).subscribe((beat: any) => {
      if (beat && beat._id && this.currentPlayingPlaylistId) {
        const currentPlaylist = this.playListData.find(p => p.id === this.currentPlayingPlaylistId);
        const beatInCurrentPlaylist = currentPlaylist?.beats?.some((b: any) => b._id === beat._id);
        if (!beatInCurrentPlaylist) {
          this.currentPlayingPlaylistId = null;
        }
      }
    });
    
    this.playerService.getState().pipe(takeUntil(this.destroy$)).subscribe((state: any) => {
      this.isPlaying = state?.playing || false;
    });
  }
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  playPlaylist(playlist: PlaylistModel, event: Event): void {
    event.stopPropagation();
    
    if (!playlist.beats || playlist.beats.length === 0) return;
    
    if (this.currentPlayingPlaylistId === playlist.id) {
      this.playerService.isCurrentPlayChangeState();
      return;
    }
    
    this.currentPlayingPlaylistId = playlist.id;
    const beatsList = JSON.parse(JSON.stringify(playlist.beats));
    this.beatsService.playerBeatsList.next(beatsList);
    this.beatsService.currentPlayBeat.next(beatsList[0]);
    this.beatsService.isMusicPlayOpen.next(true);
  }
  
  isPlaylistPlaying(playlist: PlaylistModel): boolean {
    return this.currentPlayingPlaylistId === playlist.id && this.isPlaying;
  }

  navigateTo () {
    if (this.type === 'trending') {
      this.route.navigate(['/trending-beats'])
    } else if (this.type === 'newFinds') {
      if (this.playlistSlug) {
        this.route.navigate(['/playlist', this.playlistSlug]);
      } else {
        this.route.navigate(['/playlist/newfinds']);
      }
    } else {
      let eventName = "click_all_playlists";
      let attributes = {
        Category: "playlist",
        Action: "click",
        Label: "Curated Playlist",
        userRole: this.browserService?.getCurrentRoles() ,
        userId : this.browserService?.getUserId()
      }
      this.ga4Service.sendEvent(eventName, attributes);
      this.route.navigate(['/playlists']);
    }
  }

  applyFilter(filterName: string) {
    if (filterName) {
        this.commonFunction.filterOptionList =  this.commonFunction.filterOptionList.filter((filterObj: FilterListModel) => {
          if (filterObj.ApiFilterKey === 'swipes-menu') {
              filterObj.filter_sub_list.map((filterSubMenuObj: FilterSubsListObj) => {
                if (filterSubMenuObj.key === 'trending_beats') {
                  filterSubMenuObj.isSelected = true;
                }
              })
            }
          return filterObj
        });
        this.commonFunction.sendSearchDataUrl("", 'filter');
      }
  }

  gotoRoutePath(path: string) {
    if (path) {
      this.route.navigate([path]);
      let eventName = "click_playlist";
      let playlistName = path.split('/').pop(); // Extract the playlist name from the path
      let attributes = {
        Category: "playlist",
        Action: "click",
        Label: "Currated Playlist",
        playlist_name: playlistName,
        userRole: this.browserService?.getCurrentRoles() ,
        userId : this.browserService?.getUserId()
      }
      this.ga4Service.sendEvent(eventName, attributes);

    }
  }
  prevSlide() {
    this.owlCar.prev();
  }

  nextSlide() {
    this.owlCar.next();
  }

  onChangeToggle($event: any) {
    this.commonFunction.typeOfList = $event;
  }
}
